import React, { useState } from "react";
import CalendarIcon from "@mui/icons-material/CalendarToday";
import ClickAwayListener from "@mui/material/ClickAwayListener";

import { formatDate } from "../../../helpers/metrics";
import { DatePicker, Button } from "../../../components";
import { FilterRow, PillDate, PillContainer, PanelWrapper } from "../styles";

const DatePanel = (props) => {
  const { startDate, endDate, setBeforeDate, setAfterDate, fetchData, type } = props;
  const [openBeforeDate, setOpenBeforeDate] = useState(false);
  const [openAfterDate, setOpenAfterDate] = useState(false);

  const setOpenBeforeDateHandler = (open) => {
    setOpenBeforeDate(open);
    setOpenAfterDate(false);
  };

  const setOpenAfterDateHandler = (open) => {
    setOpenBeforeDate(false);
    setOpenAfterDate(open);
  };

  const setBeforeDateField = (date) => {
    setBeforeDate(date);
    setOpenBeforeDate(false);
    setOpenAfterDate(false);
  };

  const setAfterDateField = (date) => {
    setAfterDate(date);
    setOpenBeforeDate(false);
    setOpenAfterDate(false);
  };

  const applyDate = () => {
    fetchData(type);
  };

  const handleClose = () => {
    setOpenAfterDate(false);
    setOpenBeforeDateHandler(false);
  };
  return (
    <PanelWrapper>
      <ClickAwayListener onClickAway={handleClose}>
        <FilterRow>
          <PillContainer>
            <PillDate onClick={() => setOpenBeforeDateHandler(!openBeforeDate)}>
              <CalendarIcon />
              {formatDate(startDate)}
            </PillDate>
            <DatePicker
              defaultValue={new Date(startDate)}
              open={openBeforeDate}
              setDateOpen={setOpenBeforeDate}
              setDateField={setBeforeDateField}
              maxDate={endDate ? new Date(endDate) : null}
            />
          </PillContainer>
          <PillContainer>
            <PillDate onClick={() => setOpenAfterDateHandler(!openAfterDate)}>
              <CalendarIcon /> {formatDate(endDate)}
            </PillDate>
            <DatePicker
              defaultValue={new Date(endDate)}
              open={openAfterDate}
              setDateOpen={setOpenAfterDate}
              setDateField={setAfterDateField}
              minDate={startDate ? new Date(startDate) : null}
            />
          </PillContainer>
        </FilterRow>
      </ClickAwayListener>
      <Button onClick={applyDate}>{"Apply"}</Button>
    </PanelWrapper>
  );
};

export { DatePanel };
